module.exports = __webpack_public_path__ + "static/media/10.c4baf8c0.jpeg";